type EditEsignParams = {
	id?: number;
	esign?: object;
	integrationId?: number;
	openInvolved?: boolean;
};

const openEditEsign = (params?: EditEsignParams) => Tools.$upModal.open('editEsign', params);

export default openEditEsign;
